export default function () {
  return {
    "AppSyncEndpoint": process.env.VUE_APP_APPSYNC_ENDPOINT,
    "AppSyncEndpointProxy":process.env.VUE_APP_APPSYNC_ENDPOINT_PROXY || process.env.VUE_APP_APPSYNC_ENDPOINT,
    "region": process.env.VUE_APP_REGION,
    //"authenticationType": "AWS_IAM",
    "authenticationType": "API_KEY",
    "apiKey": process.env.VUE_APP_API_KEY,

    "UserPool": process.env.VUE_APP_USERPOOL,
    "IdentityPool": process.env.VUE_APP_IDENTITYPOOL

  }
}
